module.exports = __webpack_public_path__ + "img/powered-stripe-alt.47cc6a78.svg";